import React from 'react'
import './logo.css'
import { Link } from 'react-router-dom'
import logo from './../assets/images/logo.jpg'

function Logo() {
	return (
		<Link id='logoDiv' to='/'>
			<img id='logo' src={logo} />
			<div id='smallHeader'>Geschichtsverein „Bär und Lilie“ Grainau</div>
		</Link>
	)
}

export default Logo
